import React from 'react';
import classNames from 'classnames';

import css from './IconReviewStar.module.css';

/**
 * Review star icon.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {boolean?} props.isFilled is filled with color
 * @param {string} props.label aria-label for svg image
 * @returns {JSX.Element} SVG icon
 */
const IconReviewStar = props => {
  const { className, rootClassName, isFilled, ariaLabel } = props;
  const filledOrDefault = isFilled ? css.filled : css.root;
  const classes = classNames(rootClassName || filledOrDefault, className);
  const ariaLabelMaybe = ariaLabel ? { ['aria-label']: ariaLabel } : {};

  return (
    // <svg
    //   className={classes}
    //   width="34"
    //   height="34"
    //   viewBox="0 0 34 34"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    // >
    //   <path
    //     d="M17.0002 33.6668C14.6946 33.6668 12.5279 33.2293 10.5002 32.3543C8.47239 31.4793 6.7085 30.2918 5.2085 28.7918C3.7085 27.2918 2.521 25.5279 1.646 23.5002C0.770996 21.4724 0.333496 19.3057 0.333496 17.0002C0.333496 14.6946 0.770996 12.5279 1.646 10.5002C2.521 8.47239 3.7085 6.7085 5.2085 5.2085C6.7085 3.7085 8.47239 2.521 10.5002 1.646C12.5279 0.770996 14.6946 0.333496 17.0002 0.333496C19.3057 0.333496 21.4724 0.770996 23.5002 1.646C25.5279 2.521 27.2918 3.7085 28.7918 5.2085C30.2918 6.7085 31.4793 8.47239 32.3543 10.5002C33.2293 12.5279 33.6668 14.6946 33.6668 17.0002C33.6668 19.3057 33.2293 21.4724 32.3543 23.5002C31.4793 25.5279 30.2918 27.2918 28.7918 28.7918C27.2918 30.2918 25.5279 31.4793 23.5002 32.3543C21.4724 33.2293 19.3057 33.6668 17.0002 33.6668Z"
    //     fill="#1D1B20"
    //   />
    //   <path
    //     d="M17.0002 30.3335C20.7224 30.3335 23.8752 29.0418 26.4585 26.4585C29.0418 23.8752 30.3335 20.7224 30.3335 17.0002C30.3335 13.2779 29.0418 10.1252 26.4585 7.54183C23.8752 4.9585 20.7224 3.66683 17.0002 3.66683C13.2779 3.66683 10.1252 4.9585 7.54183 7.54183C4.9585 10.1252 3.66683 13.2779 3.66683 17.0002C3.66683 20.7224 4.9585 23.8752 7.54183 26.4585C10.1252 29.0418 13.2779 30.3335 17.0002 30.3335Z"
    //     fill="white"
    //   />
    //   <path
    //     d="M10.3335 27.0002L17.0002 21.9168L23.6668 27.0002L21.1668 18.7502L27.8335 14.0002H19.6668L17.0002 5.3335L14.3335 14.0002H6.16683L12.8335 18.7502L10.3335 27.0002Z"
    //     fill="#1D1B20"
    //   />
    // </svg>
    <svg className={classes} xmlns="http://www.w3.org/2000/svg" width="11" height="12" viewBox="0 0 11 12" fill="none">
  <path fillRule="evenodd" clipRule="evenodd" d="M10.7871 4.1779C10.7163 3.963 10.5315 3.81792 10.324 3.81792H6.76277L5.88179 0.395973C5.82083 0.161444 5.62812 0 5.40787 0C5.18861 0 4.99491 0.161444 4.93494 0.395973L4.05298 3.81792H0.491708C0.284246 3.81792 0.100381 3.963 0.0295887 4.1779C-0.041204 4.39388 0.0177899 4.63496 0.177074 4.78331L2.85737 7.26169L1.50542 11.2629C1.42971 11.4876 1.49559 11.7407 1.66765 11.8868C1.83775 12.033 2.07668 12.0374 2.25169 11.8977L5.40787 9.39754L8.56405 11.8977C8.74005 12.0374 8.97799 12.033 9.14907 11.8868C9.32114 11.7407 9.38603 11.4876 9.31032 11.2629L7.95838 7.26169L10.6397 4.78331C10.7989 4.63496 10.8569 4.39388 10.7871 4.1779"/>
</svg>
  );
};

export default IconReviewStar;
